module.exports = __webpack_public_path__ + "static/media/address_new.fb133095.svg";